<template>
    <section id="sec3">
    <div class="beneficios">
        <h1 v-if="traduzir == true">Benefícios</h1>
        <h1 v-else>Benefits</h1>

        <div class="tudo">    
            <div class="esquerda">
                <div class="topico">
                    <img src="@/assets/imagens/cardapio.png" alt="cardapio">
                    <div v-if="traduzir == true">
                        <h2>Cardápio Digital</h2>
                        <p>Mostre aos clientes seus produtos.</p>
                    </div>
                    <div v-else>
                        <h2>Digital Menu</h2>
                        <p>Show your products to customers.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/pagamento.png" alt="pagamento">
                    <div v-if="traduzir == true">
                        <h2>Pagamento Online</h2>
                        <p>Facilidade em seus clientes pagarem de forma online.</p>
                    </div>
                    <div v-else>
                        <h2>Online Payment</h2>
                        <p>Make it easy for your customers to pay online.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/historico.png" alt="historico">
                    <div v-if="traduzir == true">
                        <h2>Histórico de Pedidos</h2>
                        <p>Tenha acesso a todos pedidos realizados.</p>
                    </div>
                    <div v-else>
                        <h2>Order History</h2>
                        <p>Access all completed orders.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/notificacao.png" alt="notificacao">
                    <div v-if="traduzir == true">
                        <h2>Notificações por Push</h2>
                        <p>Seus clientes recebem notificações no aplicativo do celular.</p>
                    </div>
                    <div v-else>
                        <h2>Push Notifications</h2>
                        <p>Your customers receive notifications in the mobile app.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/whatsapp.png" alt="whatsapp">
                    <div v-if="traduzir == true">
                        <h2>Integração com WhatsApp</h2>
                        <p>Envie mensagem para seus clientes no WhatsApp.</p>
                    </div>
                    <div v-else>
                        <h2>WhatsApp Integration</h2>
                        <p>Send messages to your customers on WhatsApp.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/suporte.png" alt="suporte">
                    <div v-if="traduzir == true">
                        <h2>Suporte Digital</h2>
                        <p>Ofereça suporte de ajuda aos seus clientes no aplicativo ou site.</p>
                    </div>
                    <div v-else>
                        <h2>Digital Support</h2>
                        <p>Offer customer support through the app or website.</p>
                    </div>
                </div>
            </div>
    
            <div class="direita">
                <div class="topico">
                    <img src="@/assets/imagens/agenda.png" alt="agenda">
                    <div v-if="traduzir == true">
                        <h2>Agenda</h2>
                        <p>Informe aos clientes os dias disponíveis ou permita agendar um horário de atendimento.</p>
                    </div>
                    <div v-else>
                        <h2>Schedule</h2>
                        <p>Inform customers of available days or allow them to book an appointment.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/promocao.png" alt="promocao">
                    <div v-if="traduzir == true">
                        <h2>Promoções</h2>
                        <p>Faça promoções de cupons de desconto ou junte selos e troque por produtos.</p>
                    </div>
                    <div v-else>
                        <h2>Promotions</h2>
                        <p>Create discount coupons or loyalty stamps that can be exchanged for products.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/jogos.png" alt="jogos">
                    <div v-if="traduzir == true">
                        <h2>Jogos Digitais</h2>
                        <p>Divirta-se com jogos a respeito do seu negócio e entregue prêmios a seus clientes.</p>
                    </div>
                    <div v-else>
                        <h2>Digital Games</h2>
                        <p>Engage customers with games related to your business and offer rewards.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/internet.png" alt="internet">
                    <div v-if="traduzir == true">
                        <h2>Site Institucional</h2>
                        <p>Um site para divulgar na internet o seu comércio.</p>
                    </div>
                    <div v-else>
                        <h2>Institutional Website</h2>
                        <p>A website to promote your business online.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/painel.png" alt="painel">
                    <div v-if="traduzir == true">
                        <h2>Painel Administrativo</h2>
                        <p>Gerencie o seu negócio através de um site.</p>
                    </div>
                    <div v-else>
                        <h2>Admin Panel</h2>
                        <p>Manage your business through a website.</p>
                    </div>
                </div>
    
                <div class="topico">
                    <img src="@/assets/imagens/semtaxa.png" alt="semtaxa">
                    <div v-if="traduzir == true">
                        <h2>Sem Taxas</h2>
                        <p>Não pague taxas de intermediação, tenha controle total sobre os preços.</p>
                    </div>
                    <div v-else>
                        <h2>No Fees</h2>
                        <p>Pay no intermediary fees and maintain full control over your pricing.</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
    </section>
</template>

<script>
    export default { 
    name: 'Beneficios',

    props: {
        cor: true,
        traduzir: true,
    },

}

</script>

<style src="./beneficios.scss" lang="scss" scoped></style>